import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DateTimePicker } from '@material-ui/pickers';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';

import { DateTime } from 'luxon';

const renderDateInput = props => (
    <TextField
        variant="outlined"
        fullWidth
        margin="normal"
        onClick={props.onClick}
        id={props.id}
        value={props.value}
        disabled={props.disabled}
        label={props.label}
        helperText={props.helperText}
        {...props.inputProps}
    />
);

const useStyles = makeStyles(theme => ({
    section: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3)
    },
    formContainer: {
        overflowY: 'scroll',
        height: '100%',
        padding: theme.spacing(3)
    },
    marginTop: {
        marginTop: theme.spacing(3)
    },
    image: {
        maxHeight: 300,
        maxWidth: 300,
        height: 'auto',
        width: '100%'
    },
    imageContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: theme.spacing(6)
    },
    height: {
        height: '100%'
    },
    settingsContainer: {
        height: '100%',
        padding: theme.spacing(3)
    },
}));

export default function OtherDetails(props) {

    const {
        election,
        handleElection,
        errors,
        isError,
        getErrorMessage,
        groups,
        newElection
    } = props;

    const classes = useStyles();

    return (
        <Grid container direction="row" className={newElection ? classes.height : null}>
            {newElection &&
                <Grid item xs className={classes.height}>
                    <div className={classes.imageContainer}>
                        <img className={classes.image} src='/images/step-review.png' alt="review-graphic" />
                    </div>
                </Grid>
            }
            <Grid item xs={newElection ? 7 : 12} className={newElection ? classes.formContainer : classes.settingsContainer}>
                {newElection &&
                    <Typography variant='h6' gutterBottom>
                        Other
                    </Typography>
                }
                <div className={classes.section}>
                    <Typography variant='subtitle2' gutterBottom>
                        Select the group of users that can review proposals and recommendations.
                    </Typography>
                    <TextField
                        id="input-review-group-id"
                        select
                        value={election.review_group_id}
                        onChange={handleElection('review_group_id')}
                        variant="outlined"
                        fullWidth
                        error={isError('review_group_id')}
                        helperText={getErrorMessage('review_group_id')}
                        >
                        <MenuItem value={0}>
                            Administrators Only
                        </MenuItem>
                        {groups.map(group => (
                            <MenuItem key={group.id} value={group.id}>
                                {group.title}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
                <div className={classes.section}>
                    <Typography variant='subtitle2' gutterBottom>
                        Select the group of users that can view voting results.
                    </Typography>
                    <TextField
                        id="input-results-group-id"
                        select
                        value={election.results_group_id}
                        onChange={handleElection('results_group_id')}
                        variant="outlined"
                        fullWidth
                        error={isError('results_group_id')}
                        helperText={getErrorMessage('results_group_id')}
                        >
                        <MenuItem value={0}>
                            Administrators Only
                        </MenuItem>
                        {groups.map(group => (
                            <MenuItem key={group.id} value={group.id}>
                                {group.title}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
            </Grid>
        </Grid>
    )
}
